import type { AgenticConversationResponseEvent } from 'features/knowledgeDocumentViewer/types'

/** Human-readable result count, e.g. "1 result" or "1,234 results". */
export function formatResultLabel(count: number): string {
  return count === 1 ? '1 result' : `${count.toLocaleString()} results`
}

/**
 * Shared fallback status text for a completed agentic response, used for
 * clipboard copy, collapsed thought summaries, and header timeline rows.
 */
export function getAgenticResponseStatusText(
  responseEvent: AgenticConversationResponseEvent
): string {
  return `Updated search query and found ${formatResultLabel(
    responseEvent.resultCount
  )}`
}

export function getAgenticResponseBodyText(
  responseEvent: AgenticConversationResponseEvent
): string {
  const finalResponse = responseEvent.final_response?.trim()
  if (finalResponse) return finalResponse
  const response = responseEvent.response?.trim()
  if (response) return response
  const segments = responseEvent.response_segments
    ?.map((segment) => segment.text.trim())
    .filter((text) => text.length > 0)
  if (segments?.length) return segments.join('\n\n')
  return ''
}
